module.exports = __webpack_public_path__ + "img/zoom-in.7d7737c0.svg";